import { render, staticRenderFns } from "./TableActivitiesLoading.vue?vue&type=template&id=79fb8605&"
import script from "./TableActivitiesLoading.vue?vue&type=script&lang=ts&"
export * from "./TableActivitiesLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports